<div class="card p-3 rounded-0">
  <div class="d-flex align-items-center gap-3 flex-wrap filters-container">

    <!-- Catégorie -->
    <div class="input-group">
      <label class="input-group-text" for="categorySelect">
        <i class="bi bi-tags"></i>
      </label>
      <select id="categorySelect" class="form-select" [(ngModel)]="filters.category">
        <option value="">Toutes</option>
        @for (cat of categories; track $index) {
          <option [value]="cat">{{ cat }}</option>
        }
      </select>
    </div>

    <!-- Pays -->
    <div class="input-group">
      <label class="input-group-text" for="countrySelect">
        <i class="bi bi-globe"></i>
      </label>
      <select id="countrySelect" class="form-select" [(ngModel)]="filters.country">
        <option value="">Tous</option>
        @for (country of countries; track $index) {
          <option [value]="country">{{ country }}</option>
        }
      </select>
    </div>

    <!-- Ville -->
    <div class="input-group">
      <label class="input-group-text" for="citySelect">
        <i class="bi bi-geo-alt"></i>
      </label>
      <select id="citySelect" class="form-select" [(ngModel)]="filters.city">
        <option value="">Toutes</option>
        @for (city of cities; track $index) {
          <option [value]="city">{{ city }}</option>
        }
      </select>
    </div>

    <!-- Note -->
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0">Note</label>
      <input
        type="range"
        class="form-range"
        min="0"
        max="5"
        step="0.5"
        [(ngModel)]="filters.minRating"
        style="width: 250px;"
      />
      <span class="fw-semibold">{{ filters.minRating }} ⭐+</span>
    </div>

    <!-- Rayon autour de moi -->
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="nearMeCheck"
          [(ngModel)]="filters.nearMe"
          (click)="checkGeolocation()"
        />
        <label class="form-check-label" for="nearMeCheck">
          Autour de moi
        </label>
      </div>

      @if (filters.nearMe) {
        <div class="d-flex align-items-center gap-2">
          <input
            type="range"
            class="form-range"
            min="1"
            max="100"
            step="1"
            [(ngModel)]="filters.radiusKm"
            style="width: 250px;"
          />
          <span class="fw-semibold">
            {{ filters.radiusKm }} km
          </span>
        </div>
      }
    </div>

    <!-- Tri -->
    <div class="input-group">
      <label class="input-group-text" for="sortSelect" style="cursor: pointer;" (click)="toggleOrder()">
        <i [class]="filters.order === 'asc' ? 'bi bi-sort-alpha-down' : 'bi bi-sort-alpha-up'"></i>
      </label>
      <select id="sortSelect" class="form-select" [(ngModel)]="filters.sortBy" (change)="applyFilters()">
        <option value="pertinence">Pertinence</option>
        <option value="name">Nom</option>
        <option value="city">Ville</option>
        <option value="rating">Étoiles</option>
        <option value="views">Consultations</option>
      </select>
    </div>

    <!-- Bouton -->
    <button class="btn btn-primary d-flex align-items-center gap-2 ms-auto" (click)="applyFilters()">
      <i class="bi bi-funnel"></i>
      Appliquer
    </button>
  </div>
</div>
